module.exports = __webpack_public_path__ + "static/media/NULIFESPANRX-Introduction.Notification_3-27-25.4d46fbdd.pdf";